import React from 'react';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  flag?: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Sunday Recovery System',
  promise: 'The macro-programming blueprint. Stop thinking, start executing.',
  badge: 'bg-gold-deep',
  contents: ['Macro-cycle blueprint: the 4 seasonal pillars', 'The weekly flow: strength vs metabolic distribution', 'Equipment rotation without awkward transitions', 'The holiday buffer: ready-to-go special sessions', 'The 365-day quick-start calendar']
}, {
  number: '02',
  title: 'The Metabolic Engine',
  promise: 'High-intensity sessions that get results without stopwatch fatigue.',
  badge: 'bg-crimson',
  contents: ['EMOM mastery: 20 pro-level EMOM routines', 'AMRAP architecture: scaling intensity for all levels', 'Tabata variations beyond 20/10', 'Partner finishers: high-engagement closing games', 'Team challenges and group competition dynamics']
}, {
  number: '03',
  title: 'The Strength Foundation',
  promise: 'Strength and power with limited gear: kettlebells, dumbbells, bands.',
  badge: 'bg-[#2F6FB5]',
  contents: ['Unilateral strength: getting the most out of limited gear', 'Tempo training: how to make 5 kg feel like 20', 'Compound complexes for large groups', 'Pre-hab built into the flow', 'Progressive overload scripts, hands-off tracking']
}, {
  number: '04',
  title: 'The Adaptation Matrix',
  promise: 'The "What if?" manual. Real-time answers for chaotic variables.',
  badge: 'bg-[#1C7A45]',
  flag: 'Core value',
  contents: ['The space hack: small studio or rainy-day park', 'Zero-equipment alternatives when gear is missing', 'Instant regressions: knee, back and shoulder swaps', 'The overcrowding protocol: managing 30+ people solo', 'The universal scaling table']
}, {
  number: '05',
  title: 'The Coaching Scripture',
  promise: 'High-energy coaching without burning out your voice.',
  badge: 'bg-[#5B2AA5]',
  contents: ['The 3-tier cueing system: visual, verbal, kinesthetic', 'Minute-40 motivation: what to say when they want to quit', 'Transition talk: bridging blocks without dead air', 'Post-class community retention scripts', 'Voice preservation: the pro-speaker projection technique']
}, {
  number: '06',
  title: 'The Profit & Retention Toolkit',
  promise: 'Turn classes into a business with systems that keep people coming back.',
  badge: 'bg-[#0E7490]',
  contents: ['Attendance and progress tracking templates', 'The feedback loop: organic testimonial generation', 'Referral engines: "Bring a Friend" campaigns', 'Re-activation scripts for ghosting clients', 'Content calendar to fill your bootcamp']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white" data-id="element-225" data-mp="wlp8vb1b7hnl">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-226" data-mp="11ksasmlzt7rc">
        <div className="text-center" data-id="element-227" data-mp="11neg0flevb6e">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-228" data-mp="16kemgrm6afy1">
            The complete playbook
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-229" data-mp="1algp7ifata4r">
            Inside the box set — six volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="mwp5lffry03l">
          {tomes.map(tome => <article key={tome.number} className={`flex flex-col rounded-2xl border bg-white p-6 shadow-card ${tome.flag ? 'border-gold ring-1 ring-gold' : 'border-ice-dark'}`} data-id="element-231" data-mp="rn5imyfonjpf">
              <div className="flex items-center gap-2.5" data-id="element-232" data-mp="3vaxsq7zj1yod">
                <span className={`flex h-8 w-8 items-center justify-center rounded-lg font-display text-lg text-white ${tome.badge}`} data-id="element-233" data-mp="3c7cgadu1qyb1">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-234" data-mp="3lygtb805w938">
                  Volume {tome.number}
                </span>
                {tome.flag && <span className="ml-auto rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-235" data-mp="3uxc0onexzp84">
                    {tome.flag}
                  </span>}
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-236" data-mp="8qdr5pbr0jpp">
                {tome.title}
              </h3>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-237" data-mp="3q7ws1e3gj3x">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-238" data-mp="2ais6cgmwra2f">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-239" data-mp="25lrvztj0zl5i">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-gold" data-id="element-240" data-mp="l26a84ftmtea" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}